import { CloseOutlined } from '@ant-design/icons';
import bladeStyles from './Blade.module.css';

interface BladeHeaderProps {
  title: string;
  onClose: () => void;
}

const BladeHeader = ({ title, onClose }: BladeHeaderProps) => (
  <div className={bladeStyles.header}>
    <h2 className={bladeStyles.headerTitle}>{title}</h2>
    <button className={bladeStyles.closeButton} onClick={onClose} aria-label="Close">
      <CloseOutlined />
    </button>
  </div>
);

export default BladeHeader;
